module.exports = __webpack_public_path__ + "images/navbar/blog.780715d4ce7a599ecfd2ea95c8687a57.jpg";